import { render, staticRenderFns } from "./CellDtNumberType.vue?vue&type=template&id=940038b4&scoped=true"
import script from "./CellDtNumberType.vue?vue&type=script&lang=js"
export * from "./CellDtNumberType.vue?vue&type=script&lang=js"
import style0 from "./CellDtNumberType.vue?vue&type=style&index=0&id=940038b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940038b4",
  null
  
)

export default component.exports